/**
 * Primary biometric method
 */
export var BiometricMethod;
(function (BiometricMethod) {
    /**
     * No biometry is available
     */
    BiometricMethod[BiometricMethod["none"] = 0] = "none";
    /**
     * iOS Touch ID is available
     */
    BiometricMethod[BiometricMethod["touchId"] = 1] = "touchId";
    /**
     * iOS Face ID is available
     */
    BiometricMethod[BiometricMethod["faceId"] = 2] = "faceId";
    /**
     * Android fingerprint authentication is available
     */
    BiometricMethod[BiometricMethod["fingerprintAuthentication"] = 3] = "fingerprintAuthentication";
    /**
     * Android face authentication is available
     */
    BiometricMethod[BiometricMethod["faceAuthentication"] = 4] = "faceAuthentication";
    /**
     * Android iris authentication is available
     */
    BiometricMethod[BiometricMethod["irisAuthentication"] = 5] = "irisAuthentication";
})(BiometricMethod || (BiometricMethod = {}));
//# sourceMappingURL=definitions.js.map